module.exports = __webpack_public_path__ + "static/media/3C.f7b2a6c4.svg";